export default "__VITE_ASSET__BRhju5rY__"